import React from 'react';
import { Box, Typography } from '@mui/material';
import { Form } from 'react-final-form';
import { MoButton } from '@src/components/MoButton';
import { MoModal } from '@src/components/MoModal';
import { MoSubmitButton } from '@src/components/MoSubmitButton';
import { MoTextInputField } from '@src/components/MoTextInputField';
import { getValidator, moZ } from '@src/utils/moZod';

const FormSchema = moZ.object({
  organizationAdminRejectionReason: moZ.string().trim().min(1, 'Required'),
});

type FormValues = {
  organizationAdminRejectionReason: string;
};

type ProposeNewTimesModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (organizationAdminRejectionReason: string) => Promise<void>;
};

export default function ProposeNewTimesModal({
  open,
  onClose,
  onSubmit,
}: ProposeNewTimesModalProps) {
  const handleSubmit = async ({ organizationAdminRejectionReason }: FormValues) => {
    await onSubmit(organizationAdminRejectionReason.trim());
    onClose();
  };

  return (
    <MoModal open={open} onClose={onClose} title="Propose new times" maxWidth="xs">
      <Form<FormValues>
        onSubmit={handleSubmit}
        validate={getValidator(FormSchema)}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Typography mb={2}>
              Let us know what times work better for you and we’ll do our best to find some
              availability.
            </Typography>
            <MoTextInputField name="organizationAdminRejectionReason" label="" multiline minRows={4} />
            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
              <MoButton variant="outlined" onClick={onClose}>
                Cancel
              </MoButton>
              <MoSubmitButton fullWidth={false}>Submit</MoSubmitButton>
            </Box>
          </form>
        )}
      />
    </MoModal>
  );
}
